import "./Profile.css";
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { MdOutlineAddAPhoto } from "react-icons/md";
import { useForm } from "react-hook-form";
import { storage, onUpdateEmail, updateElement, getDocument, db } from "../../../Firebase";
import { useNavigate } from "react-router-dom";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import avatar from '../../../Assets/avatar.png'
import { doc, getDoc } from "firebase/firestore";


function Profile() {


  const [currentUser, setCurrentUser] = useState({})
  const currentUserId = sessionStorage.getItem("user_id");
  const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm({ defaultValues: currentUser });
  //console.log(currentUser);
  useEffect(() => {
    const fetchData = async () => {
      const docRef = doc(db, "users", currentUserId)
      const docSnap = await getDoc(docRef);
      if (docSnap.exists) {
        setCurrentUser(docSnap.data());
        reset(docSnap.data());
        Object.keys(docSnap.data()).forEach(key => setValue(key, docSnap.data()[key]));
      }
    };

    fetchData();
  }, [currentUserId])

  const myphoto = currentUser?.photo !== undefined ? currentUser?.photo : avatar;

  const navigate = useNavigate();


  const handleFileChange = (event) => {
    handleUpload(event.target.files[0])
  };

  const handleUpload = (file) => {
    const filePath = `ìmages/${currentUserId}`
    const pathReference = ref(storage, filePath);
    uploadBytes(pathReference, file).then(() => {
      getDownloadURL(ref(storage, filePath))
        .then((url) => {
          const data = { photo: url }
          updateElement('users', currentUserId, data)
        })
    });
  }

  const onSubmit = (data) => {
    onUpdateEmail(
      currentUserId,
      data,navigate
    );
    // navigate(-1)
  };

  return (
    <div className="profile" id="profile">
      <h2>Modifier vos informations</h2>
      <div className="" style={{ background: "#FFF" }}>
        <Container fluid>
          <Row className="py-5 mx-0">
            <Col lg={4} md={6} className="text-center blocProfil">
              <label htmlFor="profil">
                <div className="updatephoto">
                  <div>
                    <img src={myphoto} alt="profil" className="imgprofil" />
                  </div>
                  <div className="iconBox">
                    <MdOutlineAddAPhoto className="fs-4" />
                  </div>
                </div>
              </label>
              <input type="file" id="profil" onChange={handleFileChange}
                className="d-none" accept=".png, .jpeg, .jpg, .svg"
              />
              <div className="vvd">
                <span className="textsapn">
                  {" "}
                  <span className="text-uppercase">
                    {currentUser.nom}
                  </span>{" "}
                  <span className="text-capitalize">
                    {currentUser.prenom}
                  </span>{" "}
                </span>{" "}
                <br />
                <span className="textsapn text-capitalize">
                  {currentUser.user_type}
                </span>
                <br />
              </div>
            </Col>
            <Col lg={8} md={6}>
              <Form className="me-auto px-md-5 w-100" onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-3" controlId="formBasicNom">
                  <Form.Label>Nom</Form.Label>
                  <Form.Control
                    defaultValue={currentUser.nom}
                    // value={currentUser.nom}
                    {...register("nom", {
                      required: true,
                      maxLength: 15,
                      pattern: /^[A-Za-z\s]+$/i
                    })}
                    type="text"
                    placeholder="Nom"
                  />
                  {errors?.nom?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
                  {errors?.nom?.type === "maxLength" && (
                    <p className="text-danger">La longueur maximal est de 15 lettres</p>
                  )}
                  {errors?.nom?.type === "pattern" && (
                    <p className="text-danger">Il ne prend que des lettres alphabétiques </p>
                  )}
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicPrenom">
                  <Form.Label>Prénom</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Prenom"
                    defaultValue={currentUser.prenom}
                    // value={currentUser.prenom}
                    {...register("prenom", {
                      required: true,
                      maxLength: 25,
                      pattern: /^[A-Za-z\s]+$/i
                    })}

                  />
                  {errors?.prenom?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
                  {errors?.prenom?.type === "maxLength" && (
                    <p className="text-danger">La longueur maximal est de 25 lettres</p>
                  )}
                  {errors?.prenom?.type === "pattern" && (
                    <p className="text-danger">Il ne prend que des lettres alphabétiques </p>
                  )}

                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    defaultValue={currentUser.email}
                    // value={currentUser.email}
                    {...register("email", {
                      required: true, maxLength: 25,
                      pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                    })}
                    type="email"
                    placeholder="Mail "
                  />
                  {errors?.email?.type === "maxLength" && (
                    <p className="text-danger">La longueur maximal est de 25 lettres</p>
                  )}
                  {errors?.email?.type === "pattern" && (
                    <p className="text-danger">Entrez un email valide</p>
                  )}
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicResidence">
                  <Form.Label>Résidence</Form.Label>
                  <Form.Control
                    defaultValue={currentUser.residence}
                    // value={currentUser.residence}
                    {...register("residence", { required: true, maxLength: 20 })}
                    type="text"
                    placeholder="Residence "
                  />
                  {errors?.residence?.type === "maxLength" && (
                    <p className="text-danger">La longueur maximal est de 20 lettres</p>
                  )}
                </Form.Group>
                <div className="d-flex justify-content-between">
                  <button
                    className="btn btn-sm  btn-danger  "
                    onClick={() => navigate(-1)}
                    variant="danger"
                  >
                    Annuler
                  </button>
                  <button
                    className="block-btn btn btn-sm"
                    type="submit"
                  >
                    Mettre a jour
                  </button>
                </div>

              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Profile;
